import React from "react";

export default function LocationSection() {
  return (
      <section className="bg-white">
        <div className="mx-auto w-full max-w-[1200px] px-4 py-12 sm:py-16">
          <div className="flex flex-col items-center justify-between gap-10 lg:flex-row lg:gap-0">
            {/* Left */}
            <div className="w-full lg:w-[600px] lg:pl-[42px] lg:py-[80px]">
              <div className="flex flex-col gap-[22px]">
                <h2 className="font-helvetica text-[42px] font-medium leading-[46px] text-[#2E5984] sm:text-[62px] sm:leading-[68px]">
                  Location
                </h2>

                <div className="font-helvetica text-[20px] font-medium leading-[28px] tracking-[0.04em] text-[#2E5984] sm:text-[24px] sm:leading-[34px]">
                  Central Langley/ Willowbrook
                </div>

                <div className="whitespace-pre-line font-helvetica text-[18px] font-normal leading-[24px] text-[#374151] sm:text-[20px]">
                  105-19925 Willowbrook Dr., Langley{"\n"}
                  Located near Willowbrook Shopping Centre
                </div>
              </div>

              {/* Buttons */}
              <div className="mt-10 flex flex-wrap items-center gap-5">
                <a
                    href="https://www.google.com/maps/dir/?api=1&destination=105-19925+Willowbrook+Dr,+Langley,+BC"
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex h-[48px] min-w-[200px] items-center justify-center rounded-full bg-[#2E5984] px-6 font-inter text-[22px] font-bold uppercase leading-[38px] text-white sm:min-w-[237px] sm:text-[30px]"
                >
                  Directions
                </a>

                <button
                    type="button"
                    className="inline-flex h-[48px] min-w-[200px] items-center justify-center gap-3 rounded-full bg-[rgba(166,166,166,0.4)] px-6 font-inter text-[22px] font-bold uppercase leading-[38px] text-white sm:w-[200px] sm:text-[30px]"
                >
                  {/* icon */}
                  <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      className="shrink-0"
                  >
                    <path
                        fill="white"
                        d="M18 8a3 3 0 1 0-2.82-4H15a3 3 0 0 0 .18 1L8.91 8.14A3 3 0 0 0 6 7a3 3 0 1 0 2.82 4l6.27 3.14A3 3 0 0 0 15 15a3 3 0 1 0 1-2.24L9.73 9.62A3 3 0 0 0 10 8.5c0-.39-.09-.76-.24-1.1l6.3-3.15A3 3 0 0 0 18 8Z"
                    />
                  </svg>
                  Share
                </button>
              </div>
            </div>

            {/* Right (map) */}
            <div className="w-full lg:w-[600px]">
              <div className="mx-auto w-full overflow-hidden rounded-[12px]">
                <iframe
                    title="Yoga7 Location Map"
                    src="https://www.google.com/maps?q=105-19925+Willowbrook+Dr,+Langley,+BC&output=embed"
                    className="h-[420px] w-full"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>
      </section>
  );
}
